import(/* webpackMode: "eager" */ "/Users/viper/code/sms/src/app/global-error.tsx");
